import { MediaData } from 'components/MediaViewer'
import { AppPreviewActions } from '.'
import { InterpolationListProps } from '..'

export interface UpdatePhotoCreationStep1Data {
    taskTitle?: string
    stepTitle?: string
    title?: string
    photoDos?: string
    photoDonts?: string
    PhotoTextOverlayDonts?: string
    examplePhotos?: MediaData[]
}

interface UpdatePhotoCreationInterpolationListData {
    photoDos: InterpolationListProps
}

export const updatePhotoCreationStep1Data = (payload: UpdatePhotoCreationStep1Data) => ({
    payload,
    type: AppPreviewActions.UPDATE_PHOTO_CREATION_STEP1_DATA,
})

export const updatePhotoCreationInterpolationListData = (payload: UpdatePhotoCreationInterpolationListData) => ({
    payload,
    type: AppPreviewActions.UPDATE_PHOTO_CREATION_PLACEHOLDER_DATA,
})
